<template>
  <v-container ref="target">
    <div class="text-center">
      <SectionTitle class="d-inline-block">Feito para todo tipo de salão</SectionTitle>
      <p class="section-subtitle mt-4">
        Do rodízio ao self-service, o autoatendimento na mesa se adapta ao seu negócio.
      </p>
    </div>

    <v-row class="mt-8">
      <v-col
        v-for="(useCase, i) in useCases"
        :key="i"
        cols="6"
        md="4"
        class="animated"
        :class="{ visible: showAll }"
        :style="{ animationDelay: `${i * 80}ms` }"
      >
        <div class="use-card">
          <div class="use-screen">
            <img
              :src="require(`@/assets/images/modelos/${useCase.image}`)"
              :alt="useCase.label"
              class="use-img"
              loading="lazy"
            />
          </div>
          <div class="use-label">
            <v-icon small color="error" class="mr-1">{{ useCase.icon }}</v-icon>
            {{ useCase.label }}
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import SectionTitle from '@/components/SectionTitle.vue';

  export default {
    name: 'TabletUseCasesSection',

    components: {
      SectionTitle,
    },

    data: () => ({
      showAll: false,
      useCases: [
        { label: 'Restaurantes', image: 'tablet-restaurante.webp', icon: 'mdi-silverware-fork-knife' },
        { label: 'Hamburguerias', image: 'tablet-hamburgueria.webp', icon: 'mdi-hamburger' },
        { label: 'Pizzarias', image: 'tablet-pizzaria.webp', icon: 'mdi-pizza' },
        { label: 'Pastelarias', image: 'tablet-pastelaria.webp', icon: 'mdi-food-croissant' },
        { label: 'Açaí e sorveterias', image: 'tablet-acaiteria.webp', icon: 'mdi-cup' },
        { label: 'Bares e pubs', image: 'tablet-bar.webp', icon: 'mdi-glass-mug-variant' },
      ],
    }),

    mounted() {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          this.showAll = true;
          observer.disconnect();
        }
      }, { threshold: 0.1 });

      observer.observe(this.$refs.target);
    },
  };
</script>

<style scoped lang="scss">
  .section-subtitle {
    font-size: 17px;
    line-height: 1.7;
    color: var(--text-muted);
    max-width: 560px;
    margin: 0 auto;

    @media (max-width: 780px) {
      font-size: 15px;
    }
  }

  .use-card {
    border-radius: 16px;
    overflow: hidden;
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    transition: transform 0.28s ease, border-color 0.28s ease, box-shadow 0.28s ease;

    &:hover {
      transform: translateY(-6px);
      border-color: rgba(244, 6, 18, 0.45);
      box-shadow: 0 10px 28px rgba(244, 6, 18, 0.1);
    }
  }

  .use-screen {
    aspect-ratio: 4 / 3;
    overflow: hidden;
  }

  /* Os renders são quadrados e com fundo recortado: o cover em 4:3 corta só as
     faixas vazias de cima e de baixo, deixando o tablet inteiro visível. */
  .use-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  .use-label {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 8px;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);

    @media (max-width: 600px) {
      font-size: 12px;
    }
  }

  .animated {
    opacity: 0;
    transform: translateY(28px);
    transition: opacity 0.45s ease, transform 0.45s ease;
  }

  .animated.visible {
    opacity: 1;
    transform: translateY(0);
  }
</style>
